import React from 'react';
import classNames from 'classnames';
import IconFont from '$/components/IconFont';
import styles from './index.module.scss';

export interface SkillButtonProps {
  className?: string;
  /** Skills 按钮展示名称 */
  name: string;
  /** Skill 分类图标，默认使用 Figma 中的 bookBold */
  icon?: string;
  id?: string;
  onClick?: () => void;
  /** 点击关闭按钮时触发，由父组件完成删除 */
  onRemove?: (id?: string) => void;
}

/**
 * 渲染 MediaInput 内使用的 Skill 标签按钮，样式对应 Figma 节点 39231:99420。
 */
function SkillButton({
  className,
  name,
  icon = 'bookBold',
  id,
  onClick,
  onRemove,
}: SkillButtonProps) {
  const canRemove = Boolean(onRemove);

  return (
    <div
      className={classNames(styles.skillButton, canRemove && styles.deletable, className)}
      id={id}
      onClick={onClick}
      aria-label={name}
    >
      <span className={styles.content}>
        <span className={styles.iconSlot}>
          <IconFont name={icon} fontSize={16} className={styles.icon} />
          {canRemove && (
            <button
              type="button"
              className={styles.removeButton}
              onClick={(e) => {
                e.stopPropagation();
                onRemove?.(id);
              }}
              aria-label={`删除${name}`}
            >
              <IconFont name="crossCircleFill" fontSize={16} className={styles.removeIcon} />
            </button>
          )}
        </span>
        <span className={styles.name}>{name}</span>
      </span>
    </div>
  );
}

export default React.memo(SkillButton);
